import { makeStyles } from 'tss-react/mui';
import { theme, colors } from '../../../theme';

/**
 * Custom hook that defines the styles for the award component.
 */
const useAwardComponentStyles = makeStyles()(() => ({
  awardsContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'bottom',
    justifyContent: 'flex-start',
    gap: theme.gap.s,
    padding: `0 ${theme.padding.xs}`,
    flexWrap: 'wrap',
    width: 800,
  },
  awardContainer: {
    width: 125,
    paddingRight: theme.padding.m,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    border: `1px solid ${colors.gray['200']}`,
    padding: theme.padding.s,
    borderRadius: theme.borderRadius.s,
    justifyContent: 'space-between',
  },
  awardInfo: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  awardName: {
    fontFamily: theme.fontFamily,
    fontSize: theme.fontSize.smaller,
    color: colors.gray['600'],
    fontWeight: 'bold',
  },
  awardDescription: {
    fontFamily: theme.fontFamily,
    fontSize: theme.fontSize.smallest,
    color: colors.gray['400'],
    textAlign: 'center',
    paddingTop: theme.padding.xs,
  },
  awardImage: {
    width: theme.iconSize,
    height: 'auto',
    marginBottom: theme.margin.s,
  },
  awardButton: {
    fontFamily: theme.fontFamily,
    fontSize: theme.fontSize.smallest,
    color: colors.white,
    backgroundColor: colors.blue['400'],
    padding: `${theme.padding.xs} ${theme.padding.s}`,
    borderRadius: theme.borderRadius.s,
    marginTop: theme.margin.s,
    cursor: 'pointer',
    border: 'none',
  },
  messageContainer: {
    fontFamily: theme.fontFamily,
    color: colors.green['400'],
    marginTop: theme.margin.m,
    fontSize: theme.fontSize.default,
    fontWeight: theme.fontWeight.medium,
    marginLeft: theme.margin.xs,
    textAlign: 'center',
  },
}));

export default useAwardComponentStyles;
